window.updateCustomInstallments = function () {
  const installments = 8;

  const productJsonEl = document.querySelector('[data-js-product-json]');
  const installmentEls = document.querySelectorAll('[data-custom-installment-price]');

  if (!productJsonEl || !installmentEls.length) return;

  const product = JSON.parse(productJsonEl.textContent);

  const selectedOptions = Array.from(
    document.querySelectorAll('.sb_variant_option:checked, [name^="option"]:checked')
  ).map(input => input.value);

  const selectedVariant = product.variants.find(function (variant) {
    return selectedOptions.every(function (option, index) {
      return variant.options[index] === option;
    });
  });

  if (!selectedVariant) return;

  const formattedValue = (selectedVariant.price / installments / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  installmentEls.forEach(function (el) {
    el.textContent = formattedValue;
  });
};

document.addEventListener('DOMContentLoaded', function () {
  window.updateCustomInstallments();
});

document.addEventListener('click', function (event) {
  if (
    event.target.closest('.radio-option') ||
    event.target.closest('.radio-option__label') ||
    event.target.closest('.sb_variant_option') ||
    event.target.closest('[name^="option"]')
  ) {
    setTimeout(window.updateCustomInstallments, 50);
    setTimeout(window.updateCustomInstallments, 150);
    setTimeout(window.updateCustomInstallments, 300);
  }
});

document.addEventListener('change', function (event) {
  if (
    event.target.matches('.sb_variant_option') ||
    event.target.matches('[name^="option"]')
  ) {
    setTimeout(window.updateCustomInstallments, 50);
    setTimeout(window.updateCustomInstallments, 150);
    setTimeout(window.updateCustomInstallments, 300);
  }
});